import Network from "@/common/lib/Network";
import Store from "@/config/store";

export default {
  setNewPassword(object) {
    let data = {
      piduser: Store.getters["application/get_application_user"].id
    };

    let post_data = {
      ds_i: {
        OUT: object
      }
    };

    return Network.execute("POST", "new_user_password", data, post_data, {
      "Content-Type": "application/json"
    });
  },

  getUserPassword() {
    return Network.execute("GET", "get_user_password_hash");
  }
};
